import apiClient from "@/app/api/client";
import type { ListParams } from "@/shared/types/api";

export const eventService = {
	list(params?: ListParams) {
		return apiClient.get("/events", { params }).then((r) => r.data);
	},
	get(id: number) {
		return apiClient.get(`/events/${id}`).then((r) => r.data);
	},
	update(id: number, data: Record<string, unknown>) {
		return apiClient.patch(`/events/${id}`, data).then((r) => r.data);
	},
};
